<template>
  <div>
    <div class="d-flex justify-content-end">
      <b-button variant="primary" @click="openAddModal" class="my-1">
        Add Income
      </b-button>
    </div>
    <b-modal id="addModal" :title="isEditMode ? 'Edit Income' : 'Add Income'" v-model="showAddModal" centered
      hide-footer>
      <b-row class="justify-content-center">
        <b-form @submit.prevent="AddIncome" class="p-3">
          <b-row>
            <b-col md="12">
              <b-form-group label="Income Date" label-for="incomeDate" class="mb-4">
                <b-form-datepicker id="incomeDate" v-model="newIncome.incomeDate" required
                  class="form-control-custom"></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Tax" label-for="tax" class="mb-4">
                <b-form-select id="tax" v-model="newIncome.tax" :options="taxOptions" required
                  class="form-control-custom">
                  <option :value="null" disabled>Select a tax</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Total" label-for="total" class="mb-4">
                <b-form-input id="total" v-model.number="newIncome.total" type="number" step="0.01" required
                  class="form-control-custom" @input="calculateTaxAmount">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Reference" label-for="reference" class="mb-4">
                <b-form-input id="reference" v-model="newIncome.reference" required
                  class="form-control-custom"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Tax Amount" label-for="taxAmount" class="mb-4">
                <b-form-input id="taxAmount" v-model="newIncome.taxAmount" readonly type="number" step="0.01"
                  class="form-control-custom">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="modal-footer d-flex justify-content-center">
            <button type="submit" class="btn btn-primary w-50">
              <b-spinner small v-if="loading" class="mx-2" /> {{ isEditMode ? 'Update' : 'Add' }}
            </button>
          </div>
        </b-form>
      </b-row>
    </b-modal>

    <b-modal id="viewModal" title="View Income" v-model="showViewModal" centered>
      <p><strong>Income Date: </strong>{{ selectedIncome.incomeDate }}</p>
      <p><strong>Reference: </strong>{{ selectedIncome.reference }}</p>
      <p><strong>Total Amount: </strong>{{ selectedIncome.total }}</p>
      <p><strong>Currency: </strong>{{ selectedIncome.currency }}</p>
      <p><strong>Tax Amount: </strong>{{ selectedIncome.taxAmount }}</p>
    </b-modal>
    <h3 v-if="incomeList.length === 0" class="text-center">No income Data</h3>
    <b-table v-if="dataLoaded" :items="incomeList" :fields="fields" :current-page="currentPage" :per-page="perPage"
      :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive striped>
      <template #cell(incomeDate)="row">
        {{ row.item.incomeDate.split('T')[0] }}
      </template>
      <template #cell(actions)="row">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
          </template>
          <b-dropdown-item @click="openViewModal(row.item)">
            <feather-icon icon="EyeIcon" class="mr-50" />
            <span>View</span>
          </b-dropdown-item>
          <b-dropdown-item v-b-modal.editModal @click="openEditModal(row.item)">
            <feather-icon icon="EditIcon" class="mr-50" />
            <span>Edit</span>
          </b-dropdown-item>
          <b-dropdown-item @click="confirmDelete(row.item)">
            <feather-icon icon="TrashIcon" class="mr-50" />
            <span>Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>

    <div v-else class="text-center p-4">
      <b-spinner variant="primary" label="Loading income data..."></b-spinner>
      <p>Loading data, please wait...</p>
    </div>

    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
    </b-col>
  </div>
</template>

<script>
import {
  BFormInput,
  BFormGroup,
  BTable,
  BPagination,
  BRow,
  BCol,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormTextarea,
  VBTooltip,
  BFormSelect,
  BBadge,
  BModal,
  VBModal,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BSpinner, BForm, BFormDatepicker, BOverlay
} from "bootstrap-vue";
import Swal from "sweetalert2";
import CreditCardIcon from "./CreditCardIcon.vue";
import ReconcileIcon from "./ReconcileIcon.vue";
import FundTransfersIcon from "./FundTransfersIcon.vue";
import AccStatementIcon from "./AccStatementIcon.vue";
import CheckTransactionIcon from "./CheckTransactionIcon.vue";
import BankStatementIcon from "./SalesReportIcon.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import SearchBar from "@/components/search-component/SearchBar.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    BFormInput,
    BFormGroup,
    BTable,
    BPagination,
    BRow,
    BCol,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormTextarea,
    BFormSelect,
    BBadge,
    BModal,
    CreditCardIcon,
    BDropdown,
    BDropdownItem,
    vSelect,
    flatPickr,
    BFormCheckbox, SearchBar,
    ReconcileIcon, BankStatementIcon, CheckTransactionIcon, FundTransfersIcon, AccStatementIcon,
    BSpinner, BForm, BFormDatepicker, BOverlay
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-modal": VBModal,
  },
  data() {
    return {
      dataLoaded: false,
      selectedIncome: {
        incomeDate: "",
        reference: "",
        total: 0,
        currency: "",
        taxAmount: 0,
      },
      isEditMode: false,
      newIncome: {
        id: null,
        incomeDate: "",
        tax: null,
        total: 0,
        reference: "",
        taxAmount: 0,
      },
      perPage: 5,
      loading: false,
      bankId: this.$route.params.id,
      totalRows: 1,
      bankName: "",
      name: "",
      description: "",
      currency: "",
      currentBalance: "",
      isActive: "",
      isExistingAccount: false,
      showAddModal: false,
      showEditModal: false,
      showAddCCModal: false,
      showViewModal: false,
      newIncome: {
        incomeDate: "",
        tax: null,
        total: 0,
        reference: "",
        taxAmount: 0,
      },
      taxOptions: [],
      items: [],
      searchTerm: "",
      sortBy: "bankName",
      sortDesc: false,
      currentPage: 1,
      incomeList: [],
      fields: [
        { key: "incomeDate", label: "Income Date", sortable: true },
        { key: "reference", label: "Reference", sortable: true },
        { key: "total", label: "Total Amount", sortable: true },
        { key: "taxAmount", label: "Tax Amount", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  methods: {
    openAddModal() {
      this.newIncome = {
        id: null,
        incomeDate: "",
        tax: null,
        total: 0,
        reference: "",
        taxAmount: 0,
      };
      this.isEditMode = false;
      this.showAddModal = true;
    },
    async confirmDelete(item) {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-danger swal-btn-spacing",
          cancelButton: "btn btn-secondary swal-btn-spacing"
        },
        buttonsStyling: false
      });

      if (result.isConfirmed) {
        this.deleteIncome(item.id);
      }
    },
    async deleteIncome(id) {
      try {
        this.loading = true;
        await this.deleteIncomeAction(id);

        Swal.fire({
          title: "Deleted!",
          text: "The income has been deleted.",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary"
          },
          buttonsStyling: false
        });

        this.fetchIncomeList(); // Refresh income list after deletion
      } catch (error) {
        console.error("Error deleting income:", error);
        Swal.fire({
          title: "Error!",
          text: "Failed to delete income. Please try again.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary"
          },
          buttonsStyling: false
        });
      } finally {
        this.loading = false;
      }
    },
    errorAdd() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    // error
    errorEdit() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    ...mapActions("taxModule", [
      "getTaxListAction",
    ]),
    ...mapActions("bankModule", ["getBankListAction", "getBankIDAction", "addBankAction", "updateBankAction"]),
    ...mapActions("incomeModule", ["getIncomeListAction", "postIncomeAction", "updateIncomeAction", "deleteIncomeAction"]),

    async fetchIncomeList() {
      this.dataLoaded = false;
      this.loading = true;
      try {
        const response = await this.getIncomeListAction(this.bankId);
        console.log('getIncomeListAction', response);
        if (response && response.length > 0) {
          this.incomeList = response;
          this.totalRows = response.length;
        } else {
          console.warn("No income data received", response);
          this.incomeList = [];
        }
      } catch (error) {
        console.error("Error fetching income list:", error);
      } finally {
        this.dataLoaded = true;
        this.loading = false;
      }
    },

    async AddIncome() {
      const actionText = this.isEditMode ? "Updating Income..." : "Adding Income...";
      const swalLoading = this.$swal({
        title: actionText,
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      this.loading = true;

      const incomeData = {
        incomeDate: this.newIncome.incomeDate,
        tax: this.newIncome.tax,
        total: parseFloat(this.newIncome.total) || 0,
        reference: this.newIncome.reference,
        taxAmount: this.newIncome.taxAmount,
        accountID: this.bankId,
        taxID: this.newIncome.tax,
        taxType: "0",
        statusID: "0",
        refID: "0",
        currency: "MUR"
      };

      console.log('incomeData', incomeData);

      try {
        let response;
        if (this.isEditMode && this.newIncome.id) {
          response = await this.updateIncomeAction({ id: this.newIncome.id, ...incomeData });
        } else {
          response = await this.postIncomeAction(incomeData);
        }

        if (response && response.success) {
          this.$swal.fire({
            title: "Success",
            text: this.isEditMode ? "Income updated successfully!" : "Income added successfully!",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          this.showAddModal = false;
          await this.fetchIncomeList();
        } else {
          throw new Error('Unexpected response format');
        }
      } catch (error) {
        this.$swal.fire({
          title: "Error",
          text: "Failed to save income. Please try again.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        console.error("Error saving income:", error);
      } finally {
        this.loading = false;
        this.$swal.close();
      }
    },

    openViewModal(income) {
      this.selectedIncome = {
        incomeDate: income.incomeDate ? income.incomeDate.split('T')[0] : "",
        reference: income.reference || "",
        total: income.total || 0,
        currency: income.currency || "MUR",
        taxAmount: income.taxAmount || 0,
      };
      this.showViewModal = true;
    },
    openEditModal(income) {
      console.log("income", income);
      this.newIncome = {
        id: income.id,
        incomeDate: income.incomeDate ? income.incomeDate.split('T')[0] : "",
        tax: income.taxID ? income.taxID : null,
        taxID: income.taxID	 ? income.taxID	 : null,
        total: income.total || 0,
        reference: income.reference || "",
        taxAmount: income.taxAmount || 0,
      };

      // Ensure tax dropdown is populated correctly
      if (income.tax) {
        const selectedTax = this.taxOptions.find(tax => tax.value == income.tax);
        if (selectedTax) {
          this.newIncome.tax = selectedTax.value;
        } else {
          this.newIncome.tax = null;
        }
      }

      // Trigger tax calculation to reflect the correct tax amount
      this.calculateTaxAmount();

      this.isEditMode = true;
      this.showAddModal = true;
    },
    calculateTaxAmount() {
      if (this.newIncome.tax && this.newIncome.total) {
        const selectedTax = this.taxOptions.find(tax => tax.value == this.newIncome.tax);
        if (selectedTax) {
          this.newIncome.taxAmount = ((parseFloat(this.newIncome.total) || 0) * selectedTax.taxAmount) / 100;
        } else {
          this.newIncome.taxAmount = 0;
        }
      } else {
        this.newIncome.taxAmount = 0;
      }
    }


  },
  computed: {
    ...mapGetters("bankModule", {
      banks: "bank",
      loading: "loading",
    }),
    calculatedTaxAmount() {
      const selectedTax = this.taxOptions.find(tax => tax.value === this.newIncome.tax);
      return selectedTax ? ((parseFloat(this.newIncome.total) || 0) * selectedTax.taxAmount) / 100 : 0;
    },
  },
  async mounted() {
    await this.fetchIncomeList();
    try {
      const response = await this.getTaxListAction();
      if (response && response.result && response.result.length > 0) {
        console.log("Tax API Response in Component:", response.result);
        this.taxOptions = response.result.map(tax => ({
          value: tax.id,
          text: `${tax.name} (${tax.code}) - ${tax.taxAmount}%`,
          taxAmount: tax.taxAmount,
        }));
      } else {
        console.warn("Tax API Response is empty or not in expected format", response);
      }
    } catch (error) {
      console.error("Component: Error fetching tax options:", error);
    }
  },
  watch: {
    'newIncome.tax': function () {
      this.calculateTaxAmount();
    },
    'newIncome.total': function () {
      this.calculateTaxAmount();
    },
    taxOptions: function (newVal) {
      if (this.isEditMode && this.newIncome.tax) {
        const selectedTax = newVal.find(tax => tax.value == this.newIncome.tax);
        if (selectedTax) {
          this.newIncome.tax = selectedTax.value;
          this.calculateTaxAmount();
        }
      }
    }
  }

};
</script>
<style>
div #viewModal footer {
  display: none !important;
}

.swal-btn-spacing {
  margin: 0 10px;
  /* Adjust spacing as needed */
}

.input-group:not(.bootstrap-touchspin):focus-within {
  box-shadow: none;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>